<router-outlet></router-outlet>

<aft-notifications></aft-notifications>
